
































import { defineComponent } from '@vue/composition-api';

const StickyFooterActionBar = defineComponent({
  props: {
    show: {
      default: true,
    },
    title: { default: '' },
    subtitle: { default: '' },
    actionText: { default: 'ตกลง' },
    cancelText: { default: 'ยกเลิก' },
    icon: { default: '/image/icons/widget-02.svg' },
    type: { default: 'submit' },
    heightClass: { default: 'h-24 w-10/12' },
    iconClass: { default: 'w-10' },
    hideCancel: { default: false },
    disabled: { default: null },
  },
  // setup() {},
});

export default StickyFooterActionBar;
